export default "__VITE_ASSET___W0bP5LY__"